import * as Sentry from '@sentry/react';

export function publishEvent(eventName: string, eventTags: { [key: string]: string }) {
  Sentry.captureEvent({
    message: eventName,
    tags: eventTags,
    level: 'info'
  });
}

export function publishMetric(metricName: string, metricValue: number, metricTags: { [key: string]: string }) {
  const metricsApi = (Sentry as any).metrics;
  if (metricsApi && typeof metricsApi.increment === 'function') {
    metricsApi.increment(metricName, metricValue, {
      tags: metricTags
    });
  }
}

export function publishTags(tags: { [key: string]: string }) {
  Object.entries(tags).forEach(([key, value]) => {
    if (key && value) {
      Sentry.setTag('p2g-' + key, value);
    }
  });
}

export function captureException(e: unknown, message: string, tags: { [key: string]: string }) {
  console.error(message, e);
  Sentry.captureException(e, {
    tags: tags
  });
}

export function capturePromiseException(e: unknown) {
  Sentry.captureException(e);
}

export function captureWarning(message: string, tags: { [key: string]: string }, params: unknown[] = []) {
  console.warn(message, ...params);
  Sentry.captureMessage(message, {
    tags: tags,
    level: 'warning'
  });
}
